export default __webpack_public_path__ + "assets/images/clubs.b64bac623719a5034dadd0c7c10916e2.png";